import PointRedeemCampaignLayout from './layout/PointRedeemCampaignLayout.vue'

const pointRedeemCampaignRoutes = [
  {
    path: 'privileges',
    component: PointRedeemCampaignLayout,
    children: [
      {
        path: 'point-redeem-campaign',
        name: 'PointRedeemCampaignList',
        component: () => import('@/views/point_redeem_campaign/PointRedeemCampaignList.vue'),
      },
      {
        path: 'point-redeem-item',
        name: 'PointRedeemItemList',
        component: () => import('@/views/point_redeem_campaign/PointRedeemItemList.vue'),
      },
    ],
  },
]

export default pointRedeemCampaignRoutes
